export default "__VITE_ASSET__r4nJ1Sz2__"